const toSnakeCase = (value: unknown): string => {
  if (value == null) return "";
  const str = String(value)
    .trim()
    .replace(/[\s\-.]+/g, " ")
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .replace(/([a-zA-Z])(\d)/g, "$1 $2")
    .replace(/(\d)([a-zA-Z])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .toLowerCase();
  return str.replace(/\s/g, "_");
};

export const snakize = (input: unknown): any => {
  if (typeof input === "string") return toSnakeCase(input);

  const seen = new WeakMap<object, any>();

  const transform = (val: any): any => {
    if (val === null || typeof val !== "object") return val;

    if (val instanceof Map) {
      if (seen.has(val)) return seen.get(val);
      const out: Record<string, any> = {};
      seen.set(val, out);
      for (const [ k, v ] of val.entries()) {
        out[ toSnakeCase(k) ] = transform(v);
      }
      return out;
    }

    if (val instanceof Set) {
      if (seen.has(val)) return seen.get(val);
      const arr: any[] = [];
      seen.set(val, arr);
      for (const item of val.values()) {
        arr.push(transform(item));
      }
      return arr;
    }

    if (Array.isArray(val)) {
      if (seen.has(val)) return seen.get(val);
      const arr: any[] = new Array(val.length);
      seen.set(val, arr);
      for (let i = 0; i < val.length; i++) {
        arr[ i ] = transform(val[ i ]);
      }
      return arr;
    }

    if (seen.has(val)) return seen.get(val);
    const out: Record<string, any> = {};
    seen.set(val, out);
    for (const key of Object.keys(val)) {
      const snakeKey = toSnakeCase(key);
      const value = val[ key ];
      out[ snakeKey ] = transform(value);
    }
    return out;
  };

  return transform(input);
};
